import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { WebFormContainerComponent } from './web.form.container/web.form.container.component';
import { TranslateModule } from "../translate/translate.module";
import { InformationBoxComponent } from "./information.box/information.box.component";
import { PageHeaderComponent } from "./page.header/page.header.component";
import { NgxMaskModule } from "ngx-mask";
import { TabComponent } from "./tabs/tab.component/tab.component";
import { TabsWrapperComponent } from "./tabs/tabs.wrapper.component/tabs.wrapper.component";
import { TabTitleTemplateDirective } from "./tabs/tabs.wrapper.component/tab.title.template";
import { PopupModule } from "@progress/kendo-angular-popup";
import { ContactPageComponent } from "./contact.us.page/contact-page.component";
import { SetPasswordComponent } from "./set.password/set.password.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ChangePasswordComponent } from "../change.password/components/change.password.component";
import { MockModule } from "../mock/modules/mock.module";
import { PasswordExpirationWarningComponent } from "./password.expiration.warning/password.expiration.warning.component";
import { DocumentAcquisitionComponent } from "./document.acquisition/document.acquisition.component";
import { NgxImageCompressService } from "ngx-image-compress";
import { CommonPipesModule } from "../pipes/common.pipes.module";
import { DocumentAcquisitionBodyComponent } from "./document.acquisition/document.acquisition.body/document.acquisition.body.component";
import { NotificationContentComponent } from "./notification.content/notification.content.component";
import { AboutPageComponent } from "./about.page/about.page.component";
import { TermsPageComponent } from "./terms.page/terms.page.component";
import { ClickableElementModule } from "../directives/clickable.element/clickable.element.module";
import { WebFormLightContainerComponent } from './web.form.light.container/web.form.light.container.component';
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { ButtonComponent } from "./button/button.component";
import { SwitchComponent } from "./switch/switch.component";
import { AccessibilityStatementPageComponent } from "./accessibility.statement.page/accessibility.statement.page.component";
import { OtherCountryLabelComponent } from "./about.page/other.country.label.component";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { LabelModule } from '@progress/kendo-angular-label';


@NgModule({
	declarations: [
		WebFormLightContainerComponent,
		//      WebFormContainerComponent,
		InformationBoxComponent,
		PageHeaderComponent,
		TabComponent,
		TabsWrapperComponent,
		TabTitleTemplateDirective,
		ContactPageComponent,
		DocumentAcquisitionComponent,
		DocumentAcquisitionBodyComponent,
		SetPasswordComponent,
		ChangePasswordComponent,
		PasswordExpirationWarningComponent,
		NotificationContentComponent,
		AboutPageComponent,
		TermsPageComponent,
		CheckboxComponent,
		ButtonComponent,
		SwitchComponent,
		AccessibilityStatementPageComponent,
		OtherCountryLabelComponent
	],
	exports: [
		InformationBoxComponent,
		ContactPageComponent,
		DocumentAcquisitionComponent,
		DocumentAcquisitionBodyComponent,
		WebFormLightContainerComponent,
		//  WebFormContainerComponent,
		TabComponent,
		NotificationContentComponent,
		TabsWrapperComponent,
		TabTitleTemplateDirective,
		PageHeaderComponent,
		SetPasswordComponent,
		ChangePasswordComponent,
		PasswordExpirationWarningComponent,
		AboutPageComponent,
		TermsPageComponent,
		CheckboxComponent,
		ButtonComponent,
		SwitchComponent,
		AccessibilityStatementPageComponent
	],
	imports: [
		CommonModule,
		TranslateModule,
		NgxMaskModule,
		PopupModule,
		ReactiveFormsModule,
		MockModule,
		CommonPipesModule,
		ClickableElementModule,
		DropDownListModule,
		LabelModule,
		FormsModule
	],
	providers: [NgxImageCompressService]
})
export class CommonComponentsModule { }
